import { browser } from '$app/env';
import type { CachedSearchResult } from '#lib/models/cachedSearch.ts';
import type { ActiveCoffeeEntry, MyCoffeesSearchState } from '#lib/models/myCoffees.ts';
import { wrap } from 'comlink';

/**
 * Don't use top level await as it is not supported in Safari yet (as of March 2026).
 * https://caniuse.com/wf-top-level-await
 */
const worker: any = browser
  ? import('./worker?worker').then((w) => wrap(new w.default()))
  : undefined;

export async function sortOrSearch(
  entries: Array<ActiveCoffeeEntry>,
  search: MyCoffeesSearchState,
): Promise<CachedSearchResult<ActiveCoffeeEntry>> {
  if (browser) {
    return (await worker).sortOrSearch(entries, search);
  } else {
    return { data: [], totalEntries: 0 };
  }
}

export async function quickSearch(
  entries: Array<ActiveCoffeeEntry>,
  filter?: string,
): Promise<Array<ActiveCoffeeEntry>> {
  if (browser) {
    return (await worker).quickSearch(entries, filter);
  } else {
    return [];
  }
}

export async function loadPage(index: number, count: number): Promise<Array<ActiveCoffeeEntry>> {
  if (browser) {
    return (await worker).loadPage(index, count);
  } else {
    return [];
  }
}
